/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RegistrationUnlayerEditor from 'shared/ui/components/editors/registration/RegistrationUnlayerEditor.vue';

const __vue_script__ = {
    name: 'AdvancedDesign',

    components: { RegistrationUnlayerEditor },

    props: {
        event: {
            type: Object,
            required: true
        },

        saveSpy: {
            type: Number,
            required: true
        },

        eventDetails: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            design: {},
            editorLoaded: false,
            isFullScreen: false,
            mergeTags: null,
        };
    },

    async mounted() {
        await this.loadDesign();

        this.mergeTags = await this.getMergeTags();
    },

    methods: {
        async getMergeTags() {
            const groups = {};

            for (const [i, section] of this.eventDetails.sections.entries()) {
                if (section.type === 'editorial') {
                    continue;
                }

                groups[`${section.type}${i}`] = {
                    name: `${section.title.en} (section ${i + 1})`,
                    rules: {
                        repeat: {
                            name: 'Repeat for each entry',
                            before: `{{#each section_${i}}}`,
                            after: '{{/each}}'
                        }
                    },
                    mergeTags: await this.getFpTypeMergeTags(section.type)
                };
            }

            return groups;
        },

        async getFpTypeMergeTags(fpType) {
            const metadata = await this.$services.metadata.getMetadataForType(this.event.id, fpType, false, true);

            const result = {};

            for (const [key, definition] of Object.entries(metadata)) {
                if (definition?.kind === 'external') continue;

                result[key] = {
                    name: definition?.label || key,
                    value: `{{${key}}}`,
                    sample: definition?.default
                };
            }

            return result;
        },

        async loadDesign() {
            try {
                const data = await this.$services.pax.getAdvancedRegistration(this.event.id);

                if (data) {
                    this.design = data.design;
                } else {
                    this.design = {};
                }
            } catch (e) {
                console.log('Failed to load design', e);
            }
        },

        /**
         * Callback when editor is loaded
         *
         * @param {Boolean} loaded editor is loaded or not
         */
        onEditorLoaded(loaded) {
            this.editorLoaded = loaded;
        },

        async saveDesign(params) {
            try {
                await this.$services.pax.setAdvancedRegistration(this.event.id, params.design, params.html);
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('registration.configuration.messages.save_success').toString(),
                    type: 'success'
                });
            } catch (e) {
                console.log('Failed to save design', e);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('registration.configuration.messages.save_failed').toString(),
                    type: 'error'
                });
            }
        },

        /**
         * Switch the full screen mode.
         */
        toggleFullScreen() {
            this.isFullScreen = !this.isFullScreen;
        },
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advanced-design unlayer-wrapper",class:{ 'unlayer-fullscreen': _vm.isFullScreen }},[(_vm.editorLoaded)?_c('a',{staticClass:"btn btn-primary btn-icon single switch-fullscreen",on:{"click":_vm.toggleFullScreen}},[_c('i',{class:_vm.isFullScreen ? 'icon-resize-small' : 'icon-resize-full-screen'})]):_vm._e(),_c('registration-unlayer-editor',{attrs:{"save-spy":_vm.saveSpy,"event":_vm.event,"merge-tags":_vm.mergeTags},on:{"loaded":_vm.onEditorLoaded,"save":_vm.saveDesign},model:{value:(_vm.design),callback:function ($$v) {_vm.design=$$v},expression:"design"}})],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "AdvancedDesign.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__